
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup/onboarding",
      function () {
        return require("private-next-pages/signup/onboarding/index.tsx");
      }
    ]);
  